import React from "react";
import { FaCar, FaGasPump, FaPalette, FaCogs, FaFilter } from "react-icons/fa";
import './MobileFilterBar.css'

export default function MobileFilterBar({ setOpen }) {

  return (
    <div className="mobile-filter-bar">

      <button onClick={() => setOpen("brand")}>
        <FaCar />
        <span>Brand</span>
      </button>
    <button onClick={() => setOpen("model")}>
    <FaCar />
    <span>Model</span>
    </button>

      <button onClick={() => setOpen("fuel")}>
        <FaGasPump />
        <span>Fuel</span>
      </button>

      <button onClick={() => setOpen("color")}>
        <FaPalette />
        <span>Color</span>
      </button>

      <button onClick={() => setOpen("feature")}>
        <FaCogs />
        <span>Features</span>
      </button>

      <button onClick={() => setOpen("all")}>
        <FaFilter />
        <span>All</span>
      </button>

    </div>
  );
}
